
import axios from 'axios'
import {
  Message
} from '@gcommon/gcommon-ui'
import {
  getErrorCode,
  getQueryString,
  NOT_NEED_ERROR_TIPS_TYPE
} from './utils'
import { generateUUID } from '@/utils/utils'
const getIdVisitor = () => {
  let idvisitor =
    getQueryString('idvisitor') ||
    getQueryString('pushdeviceid') ||
    getQueryString('ssoid')
  if (!idvisitor || idvisitor === 'null') {
    // 优先从缓存里面取
    idvisitor = localStorage.getItem('idvisitor')
    //缓存中没有就生成新的
    if (!idvisitor || idvisitor === 'null') {
      idvisitor = generateUUID()
      localStorage.setItem('idvisitor', idvisitor)
    }
  }
  return idvisitor
}
// 下载文件接口不走通用axios封装
const whiteUrls = []
// create an axios instance
const service = axios.create({
  // Vue.prototype.$env.VUE_APP_BASE_API, // url = base url + request url
  baseURL: '',
  // withCredentials: true, // send cookies when cross-domain requests
  // request timeout
  timeout: 300000
})

// request interceptor
service.interceptors.request.use(
  config => {
    const userInfoJSON = sessionStorage.getItem('userInfo');
    const cem_token = getQueryString('cem_token');
    let userInfo = {};
    if (userInfoJSON) {
      try {
        userInfo = JSON.parse(userInfoJSON) || {}
      } catch (error) {
        userInfo = {}
      }
      config.headers['usr_source'] = userInfo.usr_source || '';
      config.headers['usr_medium'] = userInfo.usr_medium || '';
      config.headers['usr_campaign'] = userInfo.usr_campaign || '';
      config.headers['usr_content'] = userInfo.usr_content || '';
      config.headers['usr_term'] = userInfo.usr_term || '';
      if (!userInfo.idvisitor || userInfo.idvisitor === 'null') {
        config.headers['idvisitor'] = generateUUID();
      } else {
        config.headers['idvisitor'] = userInfo.idvisitor;
      }
      config.headers['pushdeviceid'] = userInfo.pushdeviceid || '';
    } else {
      let uuid = getIdVisitor()
      if (!uuid || uuid === 'null') {
        uuid = generateUUID()
      }
      config.headers['idvisitor'] = uuid;
    }
    config.headers['cem_token'] = cem_token || '';
    //设置问卷提交时间
    if (config.url.indexOf('/answer') !== -1) {
      config.headers['service_date'] = sessionStorage.getItem('serviceDate') || new Date().getTime();
    }

    // do something before request is sent
    // if (getToken()) {
    //   // let each request carry token
    //   config.headers['Authorization'] = 'Bearer ' + getToken()
    //   config.headers['Locale'] = 'zh-CN' // 默认中文
    // }
    return config
  },
  error => Promise.reject(error)

)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    if (response.data.code === 200) {
      //设置问卷打开时间，直接使用服务器时间
      if (response.config.url.match(/\/v2\/survey\/public\/[\w\d]+/)) {
        sessionStorage.setItem('serviceDate', new Date(response.headers.date).getTime())
      }
      return response.data
    } else {
      if (!NOT_NEED_ERROR_TIPS_TYPE.includes(response.data.code)) {
        Message({
          message: getErrorCode(response.data.code) ? getErrorCode(response.data.code) : `${response.data.msg}`,
          dangerouslyUseHTMLString: true,
          type: 'error'
        })
      }
      return response.data
    }
  },
  error => {
    try {
      if (error && error.response) {
        const err =
          typeof error.response.data === 'object' ? error.response.data : {}
        let showMsg = true
        switch (error.response.status) {
          case 400:
            err.msg = err.msg || '请求错误'
            break
          case 401:
            showMsg = false
            if (window.location.search.includes('CDP')) {
              window?.parent?.postMessage('401', '*')
            } else if (error.response?.headers?.location) {
              window.location.href = error.response.headers.location
            } else if (error.response?.headers?.Location) {
              window.location.href = error.response.headers.Location
            } else {
              window.location.reload()
            }
            break
          case 403:
            err.msg = err.msg || '无权限访问,请联系管理员'
            break
          case 405:
            err.msg = err.msg || '当前HTTP请求方法被禁止'
            break
          case 500:
            err.msg = err.msg || '服务器错误'
            window.location.href = `${window.location.origin}/v2/front/accessFailed`
            break
          case 501:
            err.msg = err.msg || '服务器错误'
            window.location.href = `${window.location.origin}/v2/front/accessFailed`
            break
          case 502:
            err.msg =
              err.msg ||
              '代理服务器尝试执行请求时，从上游服务器接收到无效的响应'
            window.location.href = `${window.location.origin}/v2/front/accessFailed`
            break
          case 503:
            err.msg = err.msg || '服务不可用'
            break
          // case 504:
          //   err.msg =
          //     err.msg ||
          //     '代理服务器尝试执行请求时，未能及时从上游服务器收到响应'
          //     window.location.href = `${window.location.origin}/v2/front/accessFailed`
          //   break
          case 429:
            window.location.href = `${window.location.origin}/v2/front/accessFailed`
            break
          case 503:
            window.location.href = `${window.location.origin}/v2/front/accessFailed`
            break
          default:
            err.msg = err.msg || '服务错误'
            break
        }
        Message.closeAll()
        if (showMsg) {
          Message({
            message: err.msg,
            type: 'error',
            duration: 3 * 1000,
            showClose: true
          })
        }
        return Promise.reject(error.response)
      }

      // 兼容blob下载出错json提示
      if (
        error.response.data instanceof Blob &&
        error.response.data.type.toLowerCase().indexOf('json') !== -1
      ) {
        const reader = new FileReader()
        reader.readAsText(error.response.data, 'utf-8')
        reader.onload = function () {
          const errorMsg = JSON.parse(reader.result).message
          Notification.error({
            title: errorMsg,
            duration: 5000
          })
        }
      } else {
        let code = 0
        const err =
          typeof error.response.data === 'object' ? error.response.data : {}
        try {
          code = error.response.data.status
        } catch (e) {
          if (error.toString().indexOf('Error: timeout') !== -1) {
            Notification.error({
              title: '网络请求超时',
              duration: 5000
            })
            return Promise.reject(error)
          }
        }
        let showMsg = true
        switch (code) {
          case 400:
            err.msg = err.msg || '请求错误'
            break
          case 401:
            showMsg = false
            if (window.location.search.includes('CDP')) {
              window?.parent?.postMessage('401', '*')
            } else {
              if (error.response?.headers?.location) {
                window.location.href = error.response.headers.location
              } else {
                window.location.reload()
              }
            }
            break
          case 403:
            err.msg = err.msg || '无权限访问,请联系管理员'
            break
          case 405:
            err.msg = err.msg || '当前HTTP请求方法被禁止'
            break
          case 500:
            err.msg = err.msg || '服务器错误'
            break
          case 502:
            err.msg =
              err.msg ||
              '代理服务器尝试执行请求时，从上游服务器接收到无效的响应'
            break
          case 503:
            err.msg = err.msg || '服务不可用'
            break
          case 504:
            err.msg =
              err.msg ||
              '代理服务器尝试执行请求时，未能及时从上游服务器收到响应'
            break
          default:
            err.msg = err.msg || '服务错误'
            break
        }
        Message.closeAll()
        if (showMsg) {
          Message({
            message: err.msg,
            type: 'error',
            duration: 3 * 1000,
            showClose: true
          })
        }
      }
    } catch (error2) {
      // console.log(error, '')
    }
    return Promise.reject(error)
  }
)

export default service
